import { render, staticRenderFns } from "./ModalUcceAgents.vue?vue&type=template&id=8790ba9a&lang=pug&"
import script from "./ModalUcceAgents.vue?vue&type=script&lang=js&"
export * from "./ModalUcceAgents.vue?vue&type=script&lang=js&"
import style0 from "./ModalUcceAgents.vue?vue&type=style&index=0&id=8790ba9a&prod&lang=sass&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports